import {dealerLeadUrl} from '../../utils/constants/EndPoint';

export function sendDealerLead(customerData, appConfig) {
  const submitDealerLead = mapForSubmit(customerData);
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'UUID': customerData.uuid,
      'Path': window.location.pathname,
      'Source': customerData.prequalSource.value,
      'CountryCode': customerData.countryCode.value,
      'LanguageCode': customerData.languageCode
    },
    body: JSON.stringify(submitDealerLead)
  };
  const submitUrl = appConfig.exrServiceApi + dealerLeadUrl;
  return fetch(submitUrl, requestOptions)
    .then((response) => response.json())
    .catch((response) => response.json());
}

function mapForSubmit(customerData) {
  const phone = {
    preferredContact:
      customerData.preferredContactMethod.value === 'Phone' ? '1' : '0',
    time: 'nopreference',
    type: 'voice'
  };
  if (customerData.phoneNumber.value.trim() !== '') {
    phone.phoneNumber = customerData.phoneNumber.value;
  }
  return {
    companyId: {
      sequence: '1',
      source: 'FMCC Prequal',
      value: 'Ford Credit'
    },
    applicationId: {
      sequence: '2',
      source: 'FMCC Prequal',
      value: customerData.result.value?.offerId
    },
    customer: {
      firstName: customerData.firstName.value.trim(),
      middleName: '',
      lastName: customerData.lastName.value.trim(),
      phone,
      email: {
        email: customerData.email.value.trim(),
        preferredContact:
          customerData.preferredContactMethod.value === 'Email' ? '1' : '0'
      },
      streetAddress: customerData.streetAddress.value.trim(),
      addressType: 'home',
      city: customerData.city.value.trim(),
      state: customerData.stateOrProvince.value,
      postalCode: customerData.postalCode.value,
      country: customerData.countryCode.value,
      comments: customerData.dealerNotes.value
    },
    vendor: {
      source: customerData.selectedDealer.value.source,
      code: customerData.selectedDealer.value.code,
      vendorName: customerData.selectedDealer.value.vendorName,
      vendorBrand: customerData.selectedDealer.value.vendorBrand
    },
    totalApprovedAmount: customerData.totalApprovedAmount.value,
    showPreQualificationAmount: customerData.showPreQualificationAmount.value
  };
}
